import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { RoomCategoryConfig, type RoomCategory } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';
export const RoomCategoryItem: RelationFieldProps<RoomCategory> = {
  nested: getRelationFieldNames(RoomCategoryConfig),
  filters: [],
  renderItem: (item, isRelationField) => ({
    title: item?.name,
    descriptionItems: item.icon ? (
      <div
        className={cn(
          'flex items-center',
          isRelationField && 'w-full justify-between'
        )}
      >
        <span className='font-medium'>
          <div className='flex items-center gap-2'>
            <img
              src={item.icon?.get ?? ''}
              alt={item.name}
              width={20}
              height={20}
            />
          </div>
        </span>
      </div>
    ) : (
      <span />
    ),
  }),
};
